import React, { useEffect } from "react";

import { AssociateContentEmbeddedForm } from "../../../../../../common/content/forms/AssociateContentEmbeddedForm";
import { mapToCloudFileContentAssociationFormState } from "./mapToFileRecordContentAssociationFormState";
import { useCloudFileAssociateContentForm } from "./useCloudFileAssociateContentForm";

export const CloudFileAssociationContentForm = (): JSX.Element => {
    const {
        validation,
        defaultContentState,
        isDefaultContentLoading,
        form,
        lookupFileRecordId,
        cloudFileDetails,
        isEditDisabled,
        setDefaultContentState,
        onInactiveContentSelectionChange
    } = useCloudFileAssociateContentForm();

    useEffect(() => {
        if (cloudFileDetails) {
            setDefaultContentState(mapToCloudFileContentAssociationFormState(cloudFileDetails));
        }
    }, [lookupFileRecordId, cloudFileDetails]);

    return (
        <AssociateContentEmbeddedForm
            defaultContentState={defaultContentState}
            onInactiveContentSelectionChange={onInactiveContentSelectionChange}
            isEditDisabled={isEditDisabled}
            renderLabelSection={false}
            validation={validation}
            form={form}
            isDefaultContentLoading={isDefaultContentLoading}
        />
    );
};
